module.exports = __webpack_public_path__ + "img/Linkedin.54d1f8b.svg";